




















































import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { SubContent31 } from '../types'
import { answersDisplay, index2Roma, kpsDisplay } from '../utils'
import SCRenderBase from './SCRenderBase.vue'
import { SCRenderMixin } from './SCRenderMixin'

@Component({
  components: { SCRenderBase }
})
export default class SCRender31 extends Mixins(SCRenderMixin) {
  @Prop({ default: 0 }) public level!: number // 顶层为0

  public kpsDisplay = kpsDisplay
  public answersDisplay = answersDisplay

  public get shouldShowAnalysis() {
    // 题型31为嵌套题型，如果子题仍然有子题，则当题干处理，不显示该子题的解析
    const data = this.data as SubContent31
    if (!data.sub_contents || data.sub_contents.length == 0) return this.showAnalysis
    return false
  }

  public inlineQIndex31(startIndex, subIndex) {
    if (this.level == 0) {
      return this.inlineQIndex(startIndex, subIndex)
    } else {
      return '<span class="q-number-index">(' + index2Roma(subIndex) + ') </span>'
    }
  }

  public get styleObj() {
    let num = this.level * 0.5 + 1

    return {
      'padding-left': num + 'em',
      'padding-right': num + 'em'
    }
  }

  public get styleAnswerObj() {
    let num = this.level * 0.5 + 1

    return {
      'margin-left': num + 'em',
      'margin-right': num + 'em'
    }
  }

  public get styleAnalysisObj() {
    let num = this.level * 0.5 + 1
    return {
      'padding-left': num + 'em',
      'padding-right': num + 'em'
    }
  }
}
